export class ElementHelper {
    public static getCachedItems<T>(element: Element, attribute: string) {
        const value = element.getAttribute(attribute);
        if (!value) return undefined;
        try {
            return JSON.parse(value) as T;
        }
        catch(error) {
            console.error(error);
            return undefined;
        }
    }
    public static cacheItems<T>(element: Element, attribute: string, data: T) {
        let value: string;
        try {
            value = JSON.stringify(data);
        }
        catch (error) {
            console.error(error);
            return;
        }
        if (!value) return;
        element.setAttribute(attribute, value);
    }
    public static getAnchorPath = (element: HTMLAnchorElement) => {
        return new URL(element.href).pathname;
    }
}